import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";

//TODO: refactor this out to use hooks directly

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        const navigate = useNavigate();
        return (
            <Component
            location={location}
            navigate={navigate}
                {...props}
            />
        );
    }

    return ComponentWithRouterProp;
}

export default withRouter;